module.exports = __webpack_public_path__ + "img/hearts.de54f5da.png";